// extracted by mini-css-extract-plugin
export default {"Actions__selector":"Actions_Actions__selector__ADf4j","Actions__total":"Actions_Actions__total__2ocCs"};